import { blank } from "../format"
import { useAnswerSession } from "../session"
import { useBlockScope } from "./context"

interface QuoteProps { source_id: string; para: number; before: string; phrase: string; after: string }

/** The court's words with the relied phrase underlined; opens the source panel at the cited para. */
export function Quote({ source_id, para, before, phrase, after }: QuoteProps) {
  const { turn, sources } = useBlockScope()
  const openSource = useAnswerSession((s) => s.openSource)
  const src = sources[source_id]
  const label = src?.label || "Source"
  const verified = src?.verified ? (blank(src.verified_label) ? "Verified" : src.verified_label) : null
  return (
    <button
      type="button"
      className="qt"
      onClick={(e) => openSource({ turn, id: source_id, relied: { before, phrase, after }, from: e.currentTarget })}
    >
      <span className="qh">
        <span>{label}{para ? ` · para ${para}` : ""}</span>
        {verified ? <span className="qv">✓ {verified}</span> : null}
      </span>
      <span className="qx">
        “{before}<span className="ul">{phrase}</span>{after}”
      </span>
      <span className="qo">Open ↗</span>
    </button>
  )
}
